// Hand-written until wint-api-client is regenerated from a Core build that has CostForwardingController.
// Mirrors the backend enum's numeric values, which is how the API serialises enums.
export const CostForwardingState = {
  ReadyForForwarding: 0,
  OnInvoiceDraft: 1,
  Forwarded: 2,
} as const;
export type CostForwardingState = (typeof CostForwardingState)[keyof typeof CostForwardingState];

// The values Core#13482 adds to the backend's WarningCategory and WarningType enums, in the same numeric form.
export const CostForwardingWarningCategory = {
  ForwardedCosts: 8,
} as const;
export type CostForwardingWarningCategory =
  (typeof CostForwardingWarningCategory)[keyof typeof CostForwardingWarningCategory];

export const CostForwardingWarningType = {
  ForwardedCostSourceDocumentCancelled: 21,
} as const;
export type CostForwardingWarningType = (typeof CostForwardingWarningType)[keyof typeof CostForwardingWarningType];

export type CostForwardingSource = "receipt" | "incomingInvoice";

export type ForwardedCostMissingReason = "noAccess" | "notAttached";

/** A receipt's or supplier invoice's marking, as returned by api/CostForwarding. */
export interface CostForwarding {
  id: number;
  state: CostForwardingState;
  customerId: number;
  customerName?: string;
  description?: string;
  markupPercentage?: number;
  invoiceId?: number;
  invoiceSerialNumber?: number;
}

/** A null customerId removes the marking. */
export interface CostForwardingPut {
  customerId: number | null;
  description: string;
}

/** A cost marked for forwarding to a customer, as listed by GET api/CostForwarding/forwardable. */
export interface ForwardableCost {
  id: number;
  sourceDocument: string;
  receiptId?: number;
  receiptSerialNumber?: number;
  incomingInvoiceId?: number;
  supplierInvoiceNumber?: string;
  sourceDate?: string;
  // Optional when marking a cost, so it can be missing or blank.
  description?: string;
  // The response interceptor turns nulls into undefined; the amount is missing until the source is booked.
  netAmountSek?: number;
  isSelectable: boolean;
}

/** Added to the invoice POST/PUT body so the server reserves the forwarded costs in the same save. */
export interface CostForwardingInvoiceFields {
  forwardedCostIds: number[];
  costMarkupPercentage: number | null;
  attachForwardedCostDocuments: boolean;
}
